var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135468",
    "data-name": "Group 135468",
    transform: "translate(-973 -1310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135386",
    "data-name": "Group 135386",
    transform: "translate(842 659)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15500",
    "data-name": "Ellipse 15500",
    cx: 101,
    cy: 101,
    r: 101,
    transform: "translate(131 651)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "support",
    transform: "translate(975.813 1314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505720",
    "data-name": "Path 505720",
    d: "M187.787,83.61l-29.771,7.741a11.378,11.378,0,0,1-5.615.028l-31.407-7.832A11.181,11.181,0,0,1,112.518,72.7V38.386A38.386,38.386,0,0,1,150.9,0h6.864a38.386,38.386,0,0,1,38.386,38.386v34.4A11.181,11.181,0,0,1,187.787,83.61Z",
    transform: "translate(-56.97)",
    fill: "#fd9727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505721",
    "data-name": "Path 505721",
    d: "M236.527,0h-6.864a38.749,38.749,0,0,0-5.085.336,38.392,38.392,0,0,1,33.3,38.05v34.4A11.181,11.181,0,0,1,249.51,83.61l-24.236,6.3,5.885,1.467a11.375,11.375,0,0,0,5.615-.028l29.771-7.741a11.181,11.181,0,0,0,8.367-10.821v-34.4A38.386,38.386,0,0,0,236.527,0Z",
    transform: "translate(-135.729)",
    fill: "#ff6d3a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135465",
    "data-name": "Group 135465",
    transform: "translate(52.991 42.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505722",
    "data-name": "Path 505722",
    d: "M108.248,162.779h8.145V142.892h-8.145a4.333,4.333,0,0,0-4.333,4.333v11.221A4.333,4.333,0,0,0,108.248,162.779Z",
    transform: "translate(-103.915 -142.892)",
    fill: "#3d6687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505723",
    "data-name": "Path 505723",
    d: "M374.239,162.779h-8.145V142.892h8.145a4.333,4.333,0,0,1,4.333,4.333v11.221A4.333,4.333,0,0,1,374.239,162.779Z",
    transform: "translate(-288.182 -142.892)",
    fill: "#3d6687"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505724",
    "data-name": "Path 505724",
    d: "M223.117,279.912a6.1,6.1,0,0,1-4.9-5.981V260.18H191.231v13.751a6.1,6.1,0,0,1-4.9,5.981l-3.288.661v22.082h43.36V280.573Z",
    transform: "translate(-106.539 -182.862)",
    fill: "#fed9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505725",
    "data-name": "Path 505725",
    d: "M144.674,331.309l-27.066-8.439a2.43,2.43,0,0,0-2.4.556L98.186,339.562,81.16,323.426a2.43,2.43,0,0,0-2.4-.556L51.7,331.309A28.205,28.205,0,0,0,31.46,358.366V376.4a2.6,2.6,0,0,0,2.6,2.6H162.314a2.6,2.6,0,0,0,2.6-2.6V358.366A28.206,28.206,0,0,0,144.674,331.309Z",
    transform: "translate(0 -226.845)",
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505726",
    "data-name": "Path 505726",
    d: "M335.23,331.309l-27.066-8.439a2.43,2.43,0,0,0-2.4.556l-3.183,3.016,15.609,4.867a28.205,28.205,0,0,1,20.239,27.057V379H352.87a2.6,2.6,0,0,0,2.6-2.6V358.366A28.206,28.206,0,0,0,335.23,331.309Z",
    transform: "translate(-190.556 -226.845)",
    fill: "#ef2929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505727",
    "data-name": "Path 505727",
    d: "M176.449,117.2h0a33.636,33.636,0,0,1-33.636-33.636V74.107a33.636,33.636,0,0,1,33.636-33.636h0a33.636,33.636,0,0,1,33.636,33.636v9.453A33.636,33.636,0,0,1,176.449,117.2Z",
    transform: "translate(-78.262 -28.444)",
    fill: "#fed9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505728",
    "data-name": "Path 505728",
    d: "M252.455,55.2V93.911a33.649,33.649,0,0,1-25.118,32.547,33.69,33.69,0,0,0,8.517,1.089h0A33.636,33.636,0,0,0,269.49,93.911V84.459A33.622,33.622,0,0,0,252.455,55.2Z",
    transform: "translate(-137.668 -38.796)",
    fill: "#f4c892"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135466",
    "data-name": "Group 135466",
    transform: "translate(67.486 95.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505729",
    "data-name": "Path 505729",
    d: "M166.364,323.427l17.027,16.136-10.5,3.577a6.712,6.712,0,0,1-7.212-1.93L152.69,326.388l11.278-3.516A2.43,2.43,0,0,1,166.364,323.427Z",
    transform: "translate(-152.69 -322.761)",
    fill: "#d4145a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505730",
    "data-name": "Path 505730",
    d: "M273.027,323.427,256,339.563l9.517,3.242a8.264,8.264,0,0,0,8.88-2.376l12.3-14.041-11.279-3.516A2.43,2.43,0,0,0,273.027,323.427Z",
    transform: "translate(-225.299 -322.761)",
    fill: "#d4145a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505731",
    "data-name": "Path 505731",
    d: "M143.327,440.719H126.015a1.74,1.74,0,0,1-1.741-1.741v-7.668a1.74,1.74,0,0,1,1.741-1.741h17.313a1.74,1.74,0,0,1,1.741,1.741v7.668A1.74,1.74,0,0,1,143.327,440.719Z",
    transform: "translate(-65.233 -301.915)",
    fill: "#eda558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505732",
    "data-name": "Path 505732",
    d: "M196.154,45.476s-14.512-1.152-19.478-14.5c0,0-35.081,28.086-64.159,14.5v-7.09A38.386,38.386,0,0,1,150.9,0h6.864a38.386,38.386,0,0,1,38.386,38.386Z",
    transform: "translate(-56.969)",
    fill: "#fd9727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505733",
    "data-name": "Path 505733",
    d: "M236.527,0h-6.864a38.749,38.749,0,0,0-5.085.336,38.4,38.4,0,0,1,33.2,35.2c6.12,9.06,17.14,9.936,17.14,9.936v-7.09A38.386,38.386,0,0,0,236.527,0Z",
    transform: "translate(-135.729)",
    fill: "#ff6d3a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135467",
    "data-name": "Group 135467",
    transform: "translate(46.473 126.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505734",
    "data-name": "Path 505734",
    d: "M416.851,425.836a2.3,2.3,0,0,0-2.3,2.3v23.307h4.6V428.134A2.3,2.3,0,0,0,416.851,425.836Z",
    transform: "translate(-315.722 -425.836)",
    fill: "#d4145a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505735",
    "data-name": "Path 505735",
    d: "M84.277,425.836a2.3,2.3,0,0,0-2.3,2.3v23.307h4.6V428.134A2.3,2.3,0,0,0,84.277,425.836Z",
    transform: "translate(-81.979 -425.836)",
    fill: "#d4145a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505736",
    "data-name": "Path 505736",
    d: "M298.593,209.813v4.192a7.38,7.38,0,0,1-6.147,7.29l-23.127,3.966a2.3,2.3,0,1,0,.776,4.526l23.127-3.966a11.962,11.962,0,0,0,9.963-11.817v-4.192Z",
    transform: "translate(-165.833 -147.463)",
    fill: "#3d6687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505737",
    "data-name": "Path 505737",
    d: "M265.681,260.523a4.443,4.443,0,0,1-.746-8.823l7.492-1.285a4.443,4.443,0,1,1,1.5,8.758l-7.492,1.285A4.491,4.491,0,0,1,265.681,260.523Z",
    transform: "translate(-161.498 -175.953)",
    fill: "#d4145a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f4448d7bab93841b5c7b0e15524ffc4c.svg";
export { ForwardRef as ReactComponent };